import { computed, ref } from '@vue/composition-api'
import customPush from 'custom-push'
import axios from 'crypto-fetch/axios'
import { updateEvent, updateMarket, updateOutcome } from 'wap/utils/pushParser/update'
import parseTopicInfo from 'custom-push/pushParser/parseTopicInfo'
import { turnEventsToMap } from '@ms/utils/eventHandlers/convert'

export default function useFeaturedMatches() {
  // 焦点比赛列表
  const featuredMatches = ref(null)

  // 设置焦点比赛列表
  const setFeaturedMatches = (tournaments = []) => {
    const config = { tournaments: [], tournamentMap: {} }
    tournaments.forEach((x) => {
      const { events, ...rest } = x
      config.tournaments.push(rest)
      config.tournamentMap[rest.tournamentId] = turnEventsToMap(events)
    })
    featuredMatches.value = config
  }

  /**
   * 获取焦点比赛
   * @return {[type]} [description]
   */
  async function getFeaturedMatches(bffRes) {
    try {
      const parseData = (data) => {
        if (data && data.tournaments && data.tournaments.length) {
          setFeaturedMatches(data.tournaments)
          subFeaturedMatches()
        }
      }

      if (bffRes) {
        parseData(bffRes)
      } else {
        const data = await axios.get('/facts-center/query/frontend/focus-matches/v2')
        parseData(data)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const updateFeaturedMatch = (data) => {
    const { tournamentId } = parseTopicInfo(data.topic, 'event')
    const tournament = featuredMatches.value.tournamentMap[tournamentId]
    if (tournament) {
      const { map, order } = tournament
      updateEvent(map, order, data)
    }
  }

  const updateFeaturedMarket = (data) => {
    const { tournamentId, eventId } = parseTopicInfo(data[0], 'market')
    const tournament = featuredMatches.value.tournamentMap[tournamentId]

    if (tournament) {
      const event = tournament.map[eventId]
      if (event) {
        updateMarket(event, data)
      }
    }
  }

  const updateFeaturedOutcome = (data) => {
    const { tournamentId, eventId } = parseTopicInfo(data[0], 'market')
    const tournament = featuredMatches.value.tournamentMap[tournamentId]
    if (tournament) {
      const event = tournament.map[eventId]
      if (event) {
        updateOutcome(event, data)
      }
    }
  }

  // featured matches 比赛信息订阅回调函数列表
  function featuredEventPushCallback(data) {
    data = JSON.parse(data)
    updateFeaturedMatch(data)
  }
  function featuredMarketPushCallback(data) {
    data = JSON.parse(data)
    updateFeaturedMarket(data)
  }
  function featuredOddsPushCallback(data) {
    data = JSON.parse(data)
    updateFeaturedOutcome(data)
  }

  // featured matches 模块赛事添加/取消订阅
  function subFeaturedMatches(isSub = true) {
    if (featuredMatches.value) {
      const { tournaments, tournamentMap } = featuredMatches.value
      tournaments.forEach(({ tournamentId }) => {
        const { order, map } = tournamentMap[tournamentId]
        order.forEach((eventId) => {
          const { sportId, categoryId, tournamentId } = map[eventId]
          const option = {
            sportId,
            categoryId,
            tournamentId,
            eventId,
            marketIds: ['1']
          }
          customPush.pushTopic({ type: 1, ...option }, featuredEventPushCallback, isSub)
          customPush.pushTopic({ type: 2, ...option }, featuredMarketPushCallback, isSub)
          customPush.pushTopic({ type: 3, ...option }, featuredOddsPushCallback, isSub)
        })
      })
    }
  }

  const validFeaturedMatches = computed(() => {
    if (!featuredMatches.value) return null
    const { tournamentMap, tournaments } = featuredMatches.value

    const map = {}
    const expiredIds = []
    Object.entries(tournamentMap).forEach(([id, tournament]) => {
      const hasData = tournament.order.length > 0
      if (hasData) {
        map[id] = tournament
      } else {
        expiredIds.push(id)
      }
    })

    const validTournaments = tournaments.filter((x) => !expiredIds.includes(x.tournamentId))

    if (validTournaments.length) {
      return {
        tournamentMap: map,
        tournaments: validTournaments
      }
    }

    return null
  })

  return {
    featuredMatches,
    validFeaturedMatches,
    getFeaturedMatches,
    subFeaturedMatches
  }
}
